import { get, writable } from "svelte/store";
import Analytics from "../../Analytics/Analytics";
import API from "../../API/API";
import AuthStore from "../../Auth/Store";
import LoadState from "../../Enums/LoadState";
import GeoHelper from "../../Helpers/GeoHelper";
import arrayRekey from "../../Helpers/Misc/arrayRekey";
import { Layout, Paint } from "../../Map/MapLayerStyles";
import PopupStore from "../../Map/Popup/PopupStore";
import MapStore from "../../Map/Store";

const initToggleData = (name, featureCode, attributeFilters, enabled) => {
	const attributeFilterValues = {};
	for (let i = 0; i < attributeFilters.length; i++) {
		attributeFilterValues[attributeFilters[i]] = "";
	}
	return {
		name: name,
		featureCode: featureCode,
		attributeFilters: attributeFilters,
		attributeFilterValues: attributeFilterValues,
		enabled: writable(enabled),
		visible: writable(true)
	};
};
const MaritimeFeaturesStore = {
	meta: {
		initState: writable(LoadState.INIT),
		loadState: writable(LoadState.INIT),
		error: writable(""),
		codes: {
			attributeCodes: writable(null),
			featureCodes: writable(null)
		}
	},
	inputs: {
		bbox: {
			readable: writable(null),
			value: writable(null)
		},
		toggles: {
			anchorageAreas: initToggleData("Anchorage areas", "ACHARE", ["CATACH"], true),
			berths: initToggleData("Berths", "BERTHS", [], true),
			cargoTranshipmentArea: initToggleData("Cargo Transhipment area", "CTSARE", [], true),
			militaryPracticeArea: initToggleData("Military Practice area", "MIPARE", [], true)
		}
	},
	requests: [

	],
	results: {
		responses: writable([]),
		length: writable(0),
		multipage: writable(false)
	},
	actions: {
		getFeatureCodes: () => {
			return new Promise((resolve, reject) => {
				API.request("maritime-features/feature-code-descriptions")
					.then((response) => {
						const keyedFeatureCodes = arrayRekey(response.results, "feature_code");
						console.log("featureCodes", response);
						console.log("keyedFeatureCodes", keyedFeatureCodes);
						MaritimeFeaturesStore.meta.codes.featureCodes.set(keyedFeatureCodes);
						resolve(keyedFeatureCodes);
					})
					.catch((e) => {
						console.error("featureCodes error", e);
						reject(e);
					});
			});
		},
		getAttributeCodes: () => {
			return new Promise((resolve, reject) => {
				API.request("maritime-features/attribute-code-descriptions")
					.then((response) => {
						const keyedAttributes = arrayRekey(response.results, "attribute_code");
						console.log("attributeCodes", response);
						console.log("keyedAttributes", keyedAttributes);
						MaritimeFeaturesStore.meta.codes.attributeCodes.set(keyedAttributes);
						resolve(keyedAttributes);
					})
					.catch((e) => {
						console.error("attributeCodes error", e);
						reject(e);
					});
			});
		},
		init: () => {
			MaritimeFeaturesStore.meta.initState.set(LoadState.LOADING);
			Promise.all([
				MaritimeFeaturesStore.actions.getFeatureCodes(),
				MaritimeFeaturesStore.actions.getAttributeCodes()
			]).then(() => {
				console.log(MaritimeFeaturesStore.inputs.toggles.anchorageAreas);
				MaritimeFeaturesStore.actions.initMap();
				MaritimeFeaturesStore.meta.initState.set(LoadState.LOADED);
			});
		},
		initMap: () => {
			const map = MapStore.helpers.getMap();
			map.addSource("ukho_features_results", {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});
			map.addSource("ukho_features_outlines", {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});

			map.addLayer({
				id: "ukho_features_outlines",
				source: "ukho_features_outlines",
				type: "line",
				layout: {
					"line-join": "round",
					"line-cap": "round"
				},
				paint: {
					"line-color": "#000000",
					"line-width": 2
				}
			});

			map.addLayer({
				id: "ukho_features_results_polygons",
				source: "ukho_features_results",
				type: "fill",
				layout: Layout.visible,
				paint: Paint.roi
			});
			map.addLayer({
				id: "ukho_features_results_lines",
				source: "ukho_features_results",
				type: "line",
				layout: {
					"line-join": "round",
					"line-cap": "round"
				},
				paint: Paint.hurricanes.lines
			});
			map.addLayer({
				id: "ukho_features_results_points",
				source: "ukho_features_results",
				type: "circle",
				layout: Layout.visible,
				paint: Paint.hurricanes.points
			});

			const enter = (e) => {
				const props = e.features[0].properties;
				let coords = null;
				if (e.features[0].geometry.type === "Point") {
					coords = e.features[0].geometry.coordinates;
				}
				else if (e.features[0].geometry.type === "Polygon") {
					coords = e.features[0].geometry.coordinates[0][0]; // TODO: calculate center?
				}
				const attributes = JSON.parse(e.features[0].properties.attributes);

				console.log("attributes", attributes);
				let html = "<strong>" + props.feature_code_description + "</strong><br/>";
				const attrKeys = Object.keys(attributes);

				for (let i = 0; i < attrKeys.length; i++) {
					const keyName = attributes[attrKeys[i]].attribute_code_description;
					const keyValue = attributes[attrKeys[i]].value;
					html += "<b>" + keyName + "</b>: " + keyValue;
					if (i !== attrKeys.length - 1) {
						html += "<br/>";
					}
				}
				PopupStore.actions.customHtml(html, 400, coords, true);
				// PopupStore.actions.custom(JSON.parse(attributes), coords, true);
			};
			const move = enter;
			const leave = (e) => {
				PopupStore.actions.custom({}, null, false);
			};
			map.on("mouseenter", "ukho_features_results_points", (e) => {
				enter(e);
			});
			map.on("mousemove", "ukho_features_results_points", (e) => {
				move(e);
			});
			map.on("mouseleave", "ukho_features_results_points", (e) => {
				leave(e);
			});
			map.on("mouseenter", "ukho_features_results_polygons", (e) => {
				enter(e);
			});
			map.on("mousemove", "ukho_features_results_polygons", (e) => {
				move(e);
			});
			map.on("mouseleave", "ukho_features_results_polygons", (e) => {
				leave(e);
			});
		},
		deinitMap: () => {
			const map = MapStore.helpers.getMap();
			map.removeLayer("ukho_features_outlines");
			map.removeSource("ukho_features_outlines");

			map.removeLayer("ukho_features_results_points");
			map.removeLayer("ukho_features_results_lines");
			map.removeLayer("ukho_features_results_polygons");
			map.removeSource("ukho_features_results");
		},
		submit: () => {
			MaritimeFeaturesStore.meta.loadState.set(LoadState.LOADING);

			const bboxVal = get(MaritimeFeaturesStore.inputs.bbox.value);
			const strBox = JSON.stringify(bboxVal);
			console.log("bboxVal", bboxVal);
			console.log("bboxVal str", strBox);

			Analytics.event("query", { category: "Maritime Features", username: get(AuthStore.userInfo).username, box: bboxVal });

			// Loop all input toggles to create request.
			const requests = [];
			const toggleKeys = Object.keys(MaritimeFeaturesStore.inputs.toggles);
			for (let i = 0; i < toggleKeys.length; i++) {
				if (get(MaritimeFeaturesStore.inputs.toggles[toggleKeys[i]].enabled)) {
					const code = MaritimeFeaturesStore.inputs.toggles[toggleKeys[i]].featureCode;

					let url = "maritime-features/feature-data";
					url += "?feature_code=" + code;
					url += "&bounding_box=" + strBox;
					url += "&page_size=" + 2000;
					for (let j = 0; j < MaritimeFeaturesStore.inputs.toggles[toggleKeys[i]].attributeFilters.length; j++) {
						const filter = MaritimeFeaturesStore.inputs.toggles[toggleKeys[i]].attributeFilters[j];
						const value = MaritimeFeaturesStore.inputs.toggles[toggleKeys[i]].attributeFilterValues[filter];
						if (value.length > 0) {
							url += "&" + filter + "=" + encodeURIComponent(value);
						}
					}
					console.log("url", url);
					requests.push(API.get(url));
				}
			}

			Promise.all(requests)
				.then((responses) => {
					MaritimeFeaturesStore.results.responses.set(responses);

					MaritimeFeaturesStore.results.multipage.set(false);
					for (let i = 0; i < responses.length; i++) {
						const multi = get(MaritimeFeaturesStore.results.multipage);
						MaritimeFeaturesStore.results.multipage.set((responses[i].next !== null) ? true : multi);
					}

					MaritimeFeaturesStore.actions.updateMap();
					MaritimeFeaturesStore.meta.loadState.set(LoadState.LOADED);
				})
				.catch((e) => {
					console.error("response error", e);
					MaritimeFeaturesStore.meta.error.set(e.data.detail);
					MaritimeFeaturesStore.meta.loadState.set(LoadState.INIT);
				});
		},
		updateMap: () => {
			const responses = get(MaritimeFeaturesStore.results.responses);

			let allFeatureLength = 0;
			for (let i = 0; i < responses.length; i++) {
				allFeatureLength += responses[i].results.features.length;
			}
			MaritimeFeaturesStore.results.length.set(allFeatureLength);

			let allFeatures = [];
			const toggleKeys = MaritimeFeaturesStore.helpers.getResponseToggleKeys();
			for (let i = 0; i < responses.length; i++) {
				if (get(MaritimeFeaturesStore.inputs.toggles[toggleKeys[i]].visible)) {
					allFeatures = [...allFeatures, ...responses[i].results.features];
				}
			}
			const map = MapStore.helpers.getMap();
			map.getSource("ukho_features_results").setData(GeoHelper.emptyGeoJson(allFeatures));
		},
		reset: () => {
			MaritimeFeaturesStore.meta.loadState.set(LoadState.INIT);
			MaritimeFeaturesStore.meta.error.set("");
			MaritimeFeaturesStore.results.responses.set([]);
			MaritimeFeaturesStore.results.multipage.set(false);
			MaritimeFeaturesStore.results.length.set(0);

			MaritimeFeaturesStore.actions.updateMap();
		}
	},
	helpers: {
		getResponseToggleKeys: () => {
			const returnKeys = [];
			const toggleKeys = Object.keys(MaritimeFeaturesStore.inputs.toggles);
			for (let i = 0; i < toggleKeys.length; i++) {
				if (get(MaritimeFeaturesStore.inputs.toggles[toggleKeys[i]].enabled)) {
					returnKeys.push(toggleKeys[i]);
				}
			}
			return returnKeys;
		}// ,
		// rekey: (arr, key) => {
		// 	const newArr = [];
		// 	arr.forEach((value) => {
		// 		newArr[value[key]] = value;
		// 	});
		// 	return newArr;
		// }
	}
};
export default MaritimeFeaturesStore;
